/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { OperationHandler } from 'src/core/services/api/createOperationCall';
import { OperationDelayStrategies } from 'src/core/utils/api/operationDelayStrategies';
import { DisposableLifetime } from 'src/core/utils/lifetime';
import { AutoTaggingJobSwagger } from 'src/customText/core/services/autoTagging/customTextAutoTaggingSwagger';
import { AutoTaggingJobStore } from 'src/customText/core/stores/CustomTextAutoTaggingJobStore';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';

export const getAutoTaggingJobOperationHandler = (
    lifetime: DisposableLifetime,
    autoTaggingJobStoreHouse: ResourceStoreHouse<AutoTaggingJobStore>
): OperationHandler<AutoTaggingJobSwagger> => ({
    retryStrategy: res => !lifetime.isDisposed && res.data.status !== 'succeeded' && res.data.status !== 'failed',
    timeToDelay: OperationDelayStrategies.exponentialDelayStrategy,
    handleCall: data => {
        if (lifetime.isDisposed) {
            return;
        }

        const currentJobStore = autoTaggingJobStoreHouse.findById(data.jobId);

        currentJobStore.updateData({
            trainedModelLabel: data.trainedModelLabel,
            documents: data.documents,
            extractors: data.extractors,
            totalCharsCount: data.totalCharsCount,
            percentage: data.percentage,
            errors: data.status === 'failed' ? data.errors : null,
            status: data.status === 'running' ? 'inProgress' : data.status,
            createdDateTime: data.createdDateTime ? new Date(data.createdDateTime) : null,
            expirationDateTime: data.expirationDateTime ? new Date(data.expirationDateTime) : null,
            lastUpdatedDateTime: data.status === 'succeeded' ? new Date(data.lastUpdatedDateTime) : null
        });
    }
});
